<template>
  <span class="dr-biz-msg" @click="go">
    <el-badge :value="badge" :hidden="!badge" :max="99">
      <i class="el-icon-bell dr-biz-msg__icon"></i>
    </el-badge>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'

/**
 * 装修业务组件：消息中心入口
 * 读 vuex unreadMessage getter；无 getter 则 badge=0
 */
export default {
  name: 'DrMessageIcon',
  props: {
    link: { type: String, default: '/userInfo/my-order' }
  },
  computed: {
    ...mapGetters({ unreadMessage: 'unreadMessage' }),
    badge() { return Number(this.unreadMessage) || 0 }
  },
  methods: {
    go() { this.$router.push(this.link || '/userInfo/my-order') }
  }
}
</script>

<style scoped>
.dr-biz-msg { display: inline-flex; cursor: pointer; padding: 4px; }
.dr-biz-msg__icon { font-size: 20px; color: var(--theme-text-primary, #303133); transition: color .15s; }
.dr-biz-msg:hover .dr-biz-msg__icon { color: var(--theme-primary, #4d6bfe); }
</style>
